import Cookies from 'js-cookie';

jQuery(document).ready(function ($) {
    if (Cookies.get('campaign__modal') !== 'true') {

        $("#campaign__modal").addClass('modal--active');

        // Prevent events from getting pass .popup
        $(".modal__inner").on('click', function (e) {
            e.stopPropagation();
        });

        // Set cookie for modal
        $('.close_modal').on('click', function () {
            $('#campaign__modal').removeClass('modal--active');
            Cookies.set('campaign__modal', 'true', { expires: 7, secure: true });
        });

        // Set cookie when navigating away or reloading
        window.onbeforeunload = function() {
            if ($('#campaign__modal').hasClass('modal--active')) {
                Cookies.set('campaign__modal', 'true', { expires: 7, secure: true });
            }
        };
    }
});
